import { render, staticRenderFns } from "./homo.vue?vue&type=template&id=8df4c9f2&scoped=true&"
import script from "./homo.vue?vue&type=script&lang=js&"
export * from "./homo.vue?vue&type=script&lang=js&"
import style0 from "./homo.vue?vue&type=style&index=0&id=8df4c9f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df4c9f2",
  null
  
)

export default component.exports